module.exports = __webpack_public_path__ + "img/pied-piper-pp.9c350a9b.svg";